import type { TourStep } from '@/components/ui/Tour';
import type { StartTourWithCompletionKeyOptions } from '@/components/tour/PageTourHost';
import type { PageTourKey } from './registry';
import {
  type OrganizationSettingsTourOptions,
  getOrganizationSettingsTourSteps,
} from './organization-settings-tour-steps';
import { scheduleTourStepsStart } from './scheduleAutoPageTour';

export type { OrganizationSettingsTourOptions };

export const ORGANIZATION_SETTINGS_TOUR_KEY: PageTourKey = 'organization-settings';

export const ORGANIZATION_SETTINGS_LEGACY_TOUR_KEYS: PageTourKey[] = [
  'academy-profile',
  'academy-public-site',
  'academy-sports',
];

export function isOrganizationSettingsDeferredTourKey(
  tourKey: PageTourKey | null | undefined,
): boolean {
  if (!tourKey) return false;
  return (
    tourKey === ORGANIZATION_SETTINGS_TOUR_KEY ||
    ORGANIZATION_SETTINGS_LEGACY_TOUR_KEYS.includes(tourKey)
  );
}

export function scheduleOrganizationSettingsTourStart(
  startTourWithCompletionKey: (
    completionKey: string,
    steps: TourStep[],
    options?: StartTourWithCompletionKeyOptions,
  ) => void,
  options: OrganizationSettingsTourOptions = {},
): () => void {
  const steps = getOrganizationSettingsTourSteps(options);
  return scheduleTourStepsStart(
    () =>
      startTourWithCompletionKey(ORGANIZATION_SETTINGS_TOUR_KEY, steps, {
        onFinish: options.onFinish,
      }),
    steps,
  );
}
